export const adjustments = {
	title: "Ajustes",
	filename: "ajustes",
	noDataToShow: "No hay nada que mostrar para el período seleccionado",
	label: {
		pos: "Facturación en Máquinas No Integradas (POS)",
		posTax: "Tarifa de Adquirencia sobre Máquinas No Integradas (POS)",
		operatorFee: "Diaria de Operador",
		systemSetup: "Setup de Sistema",
		wifiSetup: "Setup de Wifi",
		equipmentsPurchase: "Compra de Equipos",
		equipmentsRental: "Renta de Equipos",
		zigDevicePurchase: "Compra de Comandas",
		equipmentsMaintenance: "Mantenimiento de Equipos",
		wifiAssistance: "Asistencia Técnica de Wifi",
		zigFee: "Tarifa Zig",
		totemFee: "Renta Totem",
		cardActivations: "Tarifa de Activación",
		genericOperationsFee: "Gastos Generales de Operación",
		genericServices: "Otros Servicios y Cobros",
		bonifications: "Otras Bonificaciones",
		expiredRecharges: "Recargas Expiradas",
		notUsedRecharges: "Sobrante de Recargas",
		generalZigMachineTPV: "Facturación vía adquirencia integrada ZIG",
		generalZigMachineTax: "Tarifas de Adquirencia sobre Máquinas Integradas",
		anticipationFee: "Tarifa de Anticipación",
		payments: "Pagos",
		paymentsTax: "Tarifa de Pago a Proveedores",
		reimbursements: "Reembolsos a Clientes",
		withdraw: "Retiros",
		balanceAdjustment: "Balance de Saldo",
		totenRental: "Renta de Totem",
		renegotiation: "Renegociación",
		advance: "Adelanto",
		advanceFee: "Tarifa de Adelanto",
		balanceRetention: "Retención de Saldo",
		balanceTransfer: "Transferencia Entre Places",
		residueRemain: "Retención de Residuo",
		missingCards: "Tarjetas Extraviadas",
		billingInvoice: "Cobro Factura Fiscal",
		guaranteedMinimumSupplement: "Complemento Mínimo Garantizado",
		commandFiscalPurchase: "Compra de Comanda Fiscal",
		accountsReceivableLegal: "CR - Jurídico",
		cardDiscount: "Descuento de Tarjetas",
		discountGeneralOperatingExpenses: "Descuento Gastos Generales de Operación",
		discountOperatorDailyRate: "Descuento Diaria de Operador",
		generalDiscount: "Descuento General",
		dailyCoordinatorRate: "Diarias de Coordinadores",
		dailyHeadsRate: "Diarias de Heads",
		setupDailyCoordinatorRate: "Diarias de Setup Coordinadores",
		setupDailyHeadsRate: "Diarias de Setup Heads",
		setupDailySupervisorsRate: "Diarias de Setup Supervisores",
		setupDailyTechnicalRate: "Diarias de Setup Técnico",
		setupDailyTraineeRate: "Diarias de Setup Trainee",
		dailySupervisorRate: "Diarias de Supervisores",
		dailyTechnicianRate: "Diarias de Técnico",
		dailyTraineeRate: "Diarias de Trainee",
		damagedEquipment: "Equipo Averiado",
		integratedAPPBilling: "Facturación App Integrado",
		apartCreditBilling: "Facturación Crédito Apartado",
		integratedCreditBilling: "Facturación Crédito Integrado",
		apartDebitBilling: "Facturación Débito Apartado",
		integratedDebitBilling: "Facturación Débito Integrado",
		apartBillingPIX: "Facturación PIX Apartado",
		integratedPIXBilling: "Facturación PIX Integrado",
		integratedAdvancedRechargeBilling: "Facturación Recarga Anticipado Integrado",
		interestandPenalties: "Intereses y Multa",
		softwareLicense: "Licencia de Software",
		replacedMachines: "Máquinas Reemplazadas",
		minimumGuaranteedpermachine: "Mínimo Garantizado por máquina",
		otherEquipment: "Otros Equipos",
		rebate: "Rebate",
		setupAdvancedRecharge: "Setup Recarga Anticipada",
		setupRefundSite: "Setup Sitio de Reembolso",
		acquirementfeeforIntegratedZIGApplication:
			"Tarifa de adquirencia sobre Aplicativo ZIG Integrado",
		acquiringfeeonapartCredit: "Tarifa de adquirencia sobre Crédito Apartado",
		acquiringfeeforIntegratedCredit: "Tarifa de adquirencia sobre Crédito Integrado",
		acquiringfeeforapartDebit: "Tarifa de adquirencia sobre Débito Apartado",
		acquiringfeeonIntegratedDebit: "Tarifa de adquirencia sobre Débito Integrado",
		acquiringfeeforapartPIX: "Tarifa de adquirencia sobre PIX Apartado",
		acquiringfeeforIntegratedPIX: "Tarifa de adquirencia sobre PIX Integrado",
		acquiringfeeforAdvancedRecharge: "Tarifa de adquirencia sobre Recarga Anticipada",
		refundfee: "Tarifa de Reembolso",
		relatedpartyretentionfee: "Tarifa de retención de partes relacionadas",
		rappiFee: "Tarifa Rappi",
		SMSFee: "Tarifa SMS",
		residualFee: "Tarifa sobre Residuo",
		cardtoCashExchange: "Cambio de Tarjetas por Efectivo",
		cardtoProductExchange: "Cambio de Tarjetas por Producto",
		travelFood: "Alimentación de Viaje",
		shipping: "Flete",
		accommodation: "Hospedaje",
		transport: "Transporte",
		pixRefundFee: "Tarifa Reembolso PIX",
		softwareLicenseMachine: "Licencia de Software Máquina",
		softwareLicenseTotem: "Licencia de Software Totem",
		integratedAdvanceDebitBilling: "Facturación Débito Anticipado Integrado",
		integratedAdvanceCreditBilling: "Facturación Crédito Anticipado Integrado",
		integratedAdvancePixBilling: "Facturación Pix Anticipado Integrado",
		integratedAdvanceDebitFee: "Tarifa Débito Anticipada Integrado",
		integratedAdvanceCreditFee: "Tarifa Crédito Anticipada Integrado",
		integratedAdvancePixFee: "Tarifa Pix Anticipada Integrado",
		zeDeliveryDiscount: "Descuento Zé Delivery",
		ticketPrinting: "Impresión de boletos",
		validatorRental: "Licencia de Validadores",
		zeDeliveryRetention: "Retención Zé Delivery",
		valueAddedTax: "IVA",
		moneyTPV: "TPV Efectivo",
		acquiringFeeForIntegratedInstallmentCredit:
			"Tarifa de adquirencia sobre Crédito en Cuotas Integrado",
		issuedCharge: "Cobro Emitido",
		softwareLicenseGiftback: "Licencia de Software Giftback",
		loanBracelet: "Préstamo de pulsera",
		lendingCards: "Préstamo de tarjeta",
		externalResourceContribution: "Aporte de recursos externos",
		generalZigMachineCreditIn2Installments: "TPV Crédito en cuotas 2X",
		generalZigMachineCreditIn3Installments: "TPV Crédito en cuotas 3X",
		generalZigMachineCreditIn4Installments: "TPV Crédito en cuotas 4X",
		generalZigMachineCreditIn5Installments: "TPV Crédito en cuotas 5X",
		generalZigMachineCreditIn6Installments: "TPV Crédito en cuotas 6X",
		generalZigMachineCreditIn7Installments: "TPV Crédito en cuotas 7X",
		generalZigMachineCreditIn8Installments: "TPV Crédito en cuotas 8X",
		generalZigMachineCreditIn9Installments: "TPV Crédito en cuotas 9X",
		generalZigMachineCreditIn10Installments: "TPV Crédito en cuotas 10X",
		generalZigMachineCreditIn11Installments: "TPV Crédito en cuotas 11X",
		generalZigMachineCreditIn12Installments: "TPV Crédito en cuotas 12X",
		generalZigMachineCreditIn2InstallmentsFEE: "Tarifa Crédito en Cuotas 2X",
		generalZigMachineCreditIn3InstallmentsFEE: "Tarifa Crédito en Cuotas 3X",
		generalZigMachineCreditIn4InstallmentsFEE: "Tarifa Crédito en Cuotas 4X",
		generalZigMachineCreditIn5InstallmentsFEE: "Tarifa Crédito en Cuotas 5X",
		generalZigMachineCreditIn6InstallmentsFEE: "Tarifa Crédito en Cuotas 6X",
		generalZigMachineCreditIn7InstallmentsFEE: "Tarifa Crédito en Cuotas 7X",
		generalZigMachineCreditIn8InstallmentsFEE: "Tarifa Crédito en Cuotas 8X",
		generalZigMachineCreditIn9InstallmentsFEE: "Tarifa Crédito en Cuotas 9X",
		generalZigMachineCreditIn10InstallmentsFEE: "Tarifa Crédito en Cuotas 10X",
		generalZigMachineCreditIn11InstallmentsFEE: "Tarifa Crédito en Cuotas 11X",
		generalZigMachineCreditIn12InstallmentsFEE: "Tarifa Crédito en Cuotas 12X",
		totalTpvBarIncome: "Tarifa Recepción Bar",
		totalTpvEntranceIncome: "Tarifa Recepción Taquilla",
		totalTpvEntranceIncomeConsumption: "Tarifa Recepción Consumo Taquilla",
		totalTpvBarMinimumConsumption: "Tarifa Mínima Recepción Bar",
		totalTpvBonus: "Tarifa Recepción Bono",
		bankRefund: "Reembolso bancario",
		acquirerRefund: "Reembolso adquirencia",
		advanceRenegotiation: "Renegociación de Advance",
		zigTicketsRetention: "Retención Zig Tickets",
		onlineDeliveryAcquisitionFee: "Tarifa de Adquirencia sobre Delivery Online",
		pixPreventiveBlock: "Pix - Bloqueo Preventivo",
		pixAuthorizedUnblock: "Pix - Desbloqueo Autorizado",
		pixRefundByChargeback: "Pix - Reembolso por Contracargo",
		relatedStakeholderRetentionReprocessing:
			"Reprocesamiento Retención de partes relacionadas",
		electrical: "Eléctrico",
		hydraulics: "Hidráulico",
		cleaning: "Limpieza",
		supply: "Suministro",
		other: "Otros",
	},
	table: {
		date: "Fecha de competencia",
		payDate: "Fecha de liquidación",
		category: "Categoría",
		obs: "Observación",
		noObs: "Sin observación",
		totalToReceive: "A recibir",
		totalToPay: "A pagar",
		balance: "Saldo",
		actions: "Acciones",
		total: "Total",
	},
};
